import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Set tab title and favicon
document.title = 'OptiSigns';
const favicon = document.querySelector("link[rel~='icon']");
if (favicon) {
  favicon.href = process.env.PUBLIC_URL + '/ops_logo.png';
} else {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = process.env.PUBLIC_URL + '/ops_logo.png';
  document.head.appendChild(link);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
